/**
 * Normalizes paths by replacing consecutive slashes with a single slash,
 * but preserves double slashes after a colon (as in http://)
 * Compatible with older browsers that don't support lookbehind assertions
 *
 * @param {string} path - The path to normalize
 * @return {string} - The normalized path
 *
 * Example usage:
 * normalizeSlashes("http://example.com//path///to/file")
 * Returns: "http://example.com/path/to/file"
 */
export function normalizeSlashes (path: string): string {
    let result: string = ''
    let i: number = 0

    while (i < path.length) {
        const char: string = path[i]

        // If the current character is a slash
        if (char === '/') {
            // Count consecutive slashes
            let slashCount: number = 1
            while (i + slashCount < path.length && path[i + slashCount] === '/') {
                slashCount++
            }

            // Check if these slashes are preceded by a colon
            if (i > 0 && path[i - 1] === ':') {
                // Preceded by a colon, add all slashes
                for (let j:number = 0;  j < slashCount; j++) {
                    result += '/'
                }
            } else {
                // Not preceded by a colon, add a single slash
                result += '/'
            }

            // Move the index past the slashes
            i += slashCount
        } else {
            // Add non-slash character
            result += char
            i++
        }
    }

    return result
}